import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var billListRoute = [{
  path: "list/:status",
  name: "billList",
  component: function component() {
    return import("./list.vue");
  }
}];